import http from './http';
import httpInstance from './config';
import { CREATED, OK } from '../utils/constant';
import { wOrgIdMiddleware, decryptAES, encryptAES } from '../utils/commonUtils';

const VisitsService = {
    getVisitsList: wOrgIdMiddleware(async (url,query={}) => {
      const queryString = new URLSearchParams(query).toString();
      //?${queryString}
      try {
        
        const response = await http.GET(`${url}employee-visits?${queryString}`);
        
          if(response.code===200 && response.data){
            return response.data;
          }
        
        return null;
      } catch (error) {
        console.error('Error fetching user:', error);
        // throw error;
      }
    }),
    newGetVisits:wOrgIdMiddleware(async(url,visitId,pagination)=>{
      try {
        // const orgId       = OrganizationService.getOrgId();
        const response    = await http.GET(`${url}employee-visits/${visitId}?perPage=${pagination.perPage}&page=${pagination.page}&search_query=${pagination.search_query}&is_new_ui=true`);
          if (response.code===OK && response.data) {
            return response.data;
          }
        } catch (error) {
          if(error.status){
            const resData = error.data;
            if(resData.code && resData.data){
                return resData;
            }
          }
          
          // throw error;
        } 
  }),
    getVisits:wOrgIdMiddleware(async(url,visitId)=>{
      try {
        // const orgId       = OrganizationService.getOrgId();
        const response    = await http.GET(`${url}employee-visits/${visitId}`);
          if (response.code===OK && response.data) {
            return response.data;
          }
        } catch (error) {
          if(error.status){
            const resData = error.data;
            if(resData.code && resData.data){
                return resData;
            }
          }
          
          // throw error;
        } 
  }),
    /**
     * Same as getVisits but passes organization UUID explicitly (required for patient / public flows
     * where OrganizationService.getOrgId() is unset — wOrgIdMiddleware would otherwise return false
     * without calling the API).
     */
    getVisitsWithOrgId: wOrgIdMiddleware(async (url, visitId) => {
      try {
        const response = await http.GET(`${url}employee-visits/${visitId}`);
        if (response.code === OK && response.data) {
          return response.data;
        }
      } catch (error) {
        if (error.status) {
          const resData = error.data;
          if (resData.code && resData.data) {
            return resData;
          }
        }
      }
    }, true),
  getActivityByActivityIds:wOrgIdMiddleware(async(url,activityIds=[],VisitsId)=>{
    try {
      // const orgId = OrganizationService.getOrgId();
      const response = await http.POST(`${url}employee-visits-by-activity-id/${VisitsId}`,activityIds);
      
          if (response.code===OK) {
            return response.data;
          }
        
      } catch (error) {
        if(error.status){
          const resData = error.data;
          if(resData.code && resData.data){
              return resData;
          }
        }
        
        // throw error;
      } 
  }),
  
    //Save user
    saveVisits:wOrgIdMiddleware(async (url='',data,headers={})=>{
      try {
        const response = await http.POST(`${url}employee-visits`,data,headers)
          
            if((response.code===200 || response.code===201) && response.data){
              return response.data;
            }else{
              return response;
            }
          
      } catch (error) {
        console.error('Error fetching user:', error);
        if(error.status){
          const resData = error.data;
          if(resData.code && resData.data){
              return resData;
          }
        }
        
        // throw error;
      }  
    },true),

     //Save user
     updateVisits:wOrgIdMiddleware(async (url,visitId,data)=>{
      try {
        const response = await http.PUT(`${url}employee-visits/${visitId}`,data);
        return response;
      } catch (error) {
        if(error.status){
          const resData = error.data;
          if(resData.code && resData.data){
              return resData;
          }
        }
        console.error('Error fetching user:', error);
        throw error;
      }  
    }),
    //Update Provider
    updateProvider:wOrgIdMiddleware(async (url,visitId,data)=>{
      try {
        const response = await http.PUT(`${url}update-provider/${visitId}`,data);
        return response;
      } catch (error) {
        if(error.status){
          const resData = error.data;
          if(resData.code && resData.data){
              return resData;
          }
        }
        console.error('Error updating provider:', error);
        throw error;
      }  
    }),
    // Update history review attestation (provider attestation checkbox)
    updateHistoryAttestation: wOrgIdMiddleware(async (url, visitId, data) => {
      try {
        const response = await http.PUT(`${url}update-history-attestation/${visitId}`, data);
        if (response?.code === 200 && response?.data) {
          return response.data;
        }
        return response;
      } catch (error) {
        if (error.status && error.data?.code && error.data?.data) {
          return error.data;
        }
        console.error('Error updating history attestation:', error);
        throw error;
      }
    }),
    //Delete Visits
    deleteVisits:wOrgIdMiddleware(async (url='',  visitId)=>{
        try {
          const response = await http.DELETE(`${url}employee-visits/${visitId}`);
          
            if((response?.code===200 || response?.code===201)  && response?.data){
              return response.data;
            }else{
              return response;
            }
        } catch (error) {
          if(error.status){
            const resData = error.data;
            if(resData.code && resData.data){
                return resData;
            }
          }
          console.error('Error fetching user:', error);
          throw error;
        }  
      }),
      sentResultNotification:wOrgIdMiddleware(async (url='',payload={})=>{
        const response = await http.POST(`${url}sent-notification`,payload)
        if (response.code==OK) {
         return response.data;
        }
        return response;
    }),
      addPhysicalAttachements:async (data,headers={
        'Content-Type': 'multipart/form-data'
      })=>{
        try {
          
          const response = await http.POST(`employee-visits-documents`,data,headers)
            
              if((response.code===200 || response.code===201) && response.data){
                return response.data;
              }else{
                return response;
              }
            
        } catch (error) {
          console.error('Error fetching user:', error);
          if(error.status){
            const resData = error.data;
            if(resData.code && resData.data){
                return resData;
            }
          }
          
          // throw error;
        }  
      },
      getPhysicalAttachementList: async (visitId, search = '', sortBy = 'updated_at', sortOrder = 'desc') => {
        try {
          const queryParams = new URLSearchParams();
          if (search) {
            queryParams.append('search', search);
          }
          if (sortBy) {
            queryParams.append('sort_by', sortBy);
          }
          if (sortOrder) {
            queryParams.append('sort_order', sortOrder);
          }
          const queryString = queryParams.toString();
          const response = await http.GET(`employee-visits-documents-by-visits/${visitId}${queryString ? `?${queryString}` : ''}`);
          return response;
        } catch (error) {
          console.error('Error fetching user:', error);
          // throw error;
        }
      },
      getPhysicalAttachementListByMapping: async (mappingId, search = '', sortBy = 'updated_at', sortOrder = 'desc') => {
        try {
          const queryParams = new URLSearchParams();
          if (search) {
            queryParams.append('search', search);
          }
          if (sortBy) {
            queryParams.append('sort_by', sortBy);
          }
          if (sortOrder) {
            queryParams.append('sort_order', sortOrder);
          }
          const queryString = queryParams.toString();
          const response = await http.GET(`employee-visits-documents-by-visit-mapping/${mappingId}${queryString ? `?${queryString}` : ''}`);
          return response;
        } catch (error) {
          console.error('Error fetching documents by mapping:', error);
          // throw error;
        }
      },
      deletePhysicalAttachement:async (AttachmentId)=>{
        try {
         await http.DELETE(`employee-visits-documents/${AttachmentId}`);
          
        } catch (error) {
          if(error.status){
            const resData = error.data;
            if(resData.code && resData.data){
                return resData;
            }
          }
          console.error('Error fetching user:', error);
          throw error;
        }  
      },
      /** Queue-based transcription pipeline (audio_records) */
      submitAudioDraft: async (formData) => {
        try {
          const response = await http.POSTwithoutAES(`audio/draft`, formData);
          if ((response?.code === OK || response?.code === CREATED) && response?.data != null) {
            return decryptAES(response.data);
          }
          return response ?? null;
        } catch (error) {
          console.error('Error submitting audio draft:', error);
          return null;
        }
      },
      getAudioDraftMeta: async (visitId) => {
        try {
          const response = await http.GET(`audio/draft?visit_id=${encodeURIComponent(visitId)}`);
          if (response.code === OK && response.data != null) {
            return response.data;
          }
          return null;
        } catch (error) {
          return null;
        }
      },
      fetchAudioDraftStreamBlob: async (visitId) => {
        if (!visitId) return null;
        try {
          const res = await httpInstance.get(
            `audio/draft/stream?visit_id=${encodeURIComponent(String(visitId))}`,
            { responseType: 'blob' }
          );
          if (res.status === 200 && res.data instanceof Blob && res.data.size > 0) {
            return res.data;
          }
          return null;
        } catch (error) {
          console.error('Error streaming audio draft:', error);
          return null;
        }
      },
      deleteAudioDraft: async (visitId) => {
        try {
          const response = await http.DELETE(`audio/draft?visit_id=${encodeURIComponent(visitId)}`);
          return response?.code === OK;
        } catch (error) {
          console.error('Error deleting audio draft:', error);
          return false;
        }
      },
      /** Removes all visit audio, transcripts, and merged clinical note (Rerecord). */
      resetVisitVoiceDocumentation: async (visitId) => {
        try {
          const response = await http.DELETE(
            `audio/visit-documentation?visit_id=${encodeURIComponent(visitId)}`
          );
          return response?.code === OK;
        } catch (error) {
          console.error('Error resetting visit voice documentation:', error);
          return false;
        }
      },
      submitAudio: async (formData) => {
        try {
          const response = await http.POSTwithoutAES(`audio/submit`, formData);
          if ((response?.code === OK || response?.code === CREATED) && response?.data != null) {
            /** UAT/prod: jsonResponse encrypts `data`; POSTwithoutAES does not decrypt (unlike GET). Decrypt here so `id` is available for polling. */
            return decryptAES(response.data);
          }
          return response ?? null;
        } catch (error) {
          console.error('Error submitting audio:', error);
          if (error.status) {
            const resData = error.data;
            if (resData.code && resData.data) {
              return resData;
            }
          }
          return null;
        }
      },
      getAudioList: async (visitId) => {
        try {
          const response = await http.GET(`audio/list?visit_id=${encodeURIComponent(visitId)}`);
          if (response.code === OK && response.data != null) {
            let d = response.data;
            if (Array.isArray(d)) {
              return d;
            }
            if (typeof d === 'object' && Array.isArray(d.data)) {
              return d.data;
            }
            if (typeof d === 'object' && d !== null) {
              const values = Object.values(d);
              if (values.length && typeof values[0] === 'object') return values;
            }
          }
          return [];
        } catch (error) {
          console.error('Error loading audio list:', error);
          return [];
        }
      },
      /**
       * Streams a stored recording for playback (`GET audio/{id}/stream`). Uses axios blob response (not encrypted JSON envelope).
       * @param {string|number} audioRecordId
       * @returns {Promise<Blob|null>}
       */
      fetchAudioStreamBlob: async (audioRecordId) => {
        if (audioRecordId == null || audioRecordId === '') return null;
        try {
          const res = await httpInstance.get(
            `audio/${encodeURIComponent(String(audioRecordId))}/stream`,
            { responseType: 'blob' }
          );
          if (res.status === 200 && res.data instanceof Blob && res.data.size > 0) {
            return res.data;
          }
          return null;
        } catch (error) {
          console.error('Error streaming audio:', error);
          return null;
        }
      },
      /**
       * Purpose: Voice-first polling — transcription/merge queue flags, lock state, transcript segments (oldest→newest).
       * Inputs: visitId
       * Output: API body object or null
       */
      getVisitVoiceProcessingStatus: async (visitId) => {
        try {
          const response = await http.GET(
            `audio/visit-voice-status?visit_id=${encodeURIComponent(visitId)}`
          );
          if (response?.code === 401 || response?.code === 403) {
            return { __authError: true };
          }
          const msg = String(response?.message || "");
          if (/unauthenticated|invalid token|token/i.test(msg)) {
            return { __authError: true };
          }
          if (response.code === OK && response.data != null) {
            return response.data;
          }
          return null;
        } catch (error) {
          console.error('Error loading visit voice status:', error);
          return null;
        }
      },
      /**
       * Purpose: Voice-first merged note — all completed visit transcripts → one structured clinical note.
       * Inputs: visitId (string|number); options.forceOverwrite (bool) bypasses edit lock (409 NOTE_LOCKED otherwise)
       * Output: { success: true, data: detailPayload } | { success: false, locked: true, message } | { success: false, error }
       * Side effects: HTTP POST to audio/generate-merged-note (uses axios directly so 409 is readable; POSTwithoutAES drops non-2xx)
       */
      generateMergedClinicalNote: async (visitId, options = {}) => {
        try {
          const res = await httpInstance.post(
            `audio/generate-merged-note`,
            encryptAES({
              visit_id: visitId,
              force_overwrite: options.forceOverwrite === true,
            }),
            { headers: { 'Content-Type': 'application/json' } }
          );
          const body = res.data;
          if ((body?.code === OK || body?.code === CREATED) && body?.data != null) {
            return { success: true, data: decryptAES(body.data) };
          }
          return { success: false, error: body?.message || 'Unexpected response', raw: body };
        } catch (error) {
          const resp = error?.response;
          const body = resp?.data;
          const decryptedData = body?.data != null ? decryptAES(body.data) : body?.data;
          const locked =
            resp?.status === 409 ||
            body?.code === 409 ||
            (typeof decryptedData === 'object' && decryptedData?.code === 'NOTE_LOCKED');
          if (locked) {
            const msg = (typeof decryptedData === 'object' && decryptedData?.message)
              ? decryptedData.message
              : body?.message;
            return {
              success: false,
              locked: true,
              message: msg || 'Clinical note was edited. Open chart to regenerate or unlock.',
            };
          }
          console.error('Error generating merged clinical note:', error);
          return {
            success: false,
            locked: false,
            error: body?.message || error?.message || 'Could not generate merged note.',
            raw: body,
          };
        }
      },
      getAiNotes: async (visitId) => {
        try {
          const response = await http.GET(`audio/notes?visit_id=${encodeURIComponent(visitId)}`);
          if (response?.code === OK && response?.data != null) {
            let d = response.data;
            if (Array.isArray(d)) return d;
            if (typeof d === 'object' && Array.isArray(d.data)) return d.data;
            if (typeof d === 'object' && d !== null) {
              const values = Object.values(d);
              if (values.length && typeof values[0] === 'object') return values;
            }
          }
          return [];
        } catch (error) {
          console.error('Error loading AI notes:', error);
          return [];
        }
      },
      getAiNoteById: async (noteId) => {
        try {
          const response = await http.GET(`audio/notes/${noteId}`);
          if (response?.code === OK && response?.data != null) {
            return response.data;
          }
          return null;
        } catch (error) {
          console.error('Error loading AI note:', error);
          return null;
        }
      },
      updateAiNote: async (noteId, visitId, notesCollection, options = {}) => {
        try {
          const body = {
            visit_id: visitId,
            notes_collection: notesCollection ?? [],
            user_edited: options.userEdited === true,
          };
          if (options.releaseVoiceMergeLock === true) {
            body.release_voice_merge_lock = true;
          }
          if (options.editedSectionKeys !== undefined) {
            body.edited_section_keys = options.editedSectionKeys;
          }
          const response = await http.PUT(`audio/notes/${noteId}`, body);
          if ((response?.code === OK || response?.code === CREATED) && response?.data != null) {
            return response.data;
          }
          return response ?? null;
        } catch (error) {
          console.error('Error saving AI note:', error);
          return null;
        }
      },
      finalizeAiNote: async (noteId, visitId, acknowledged, action = "finalize") => {
        try {
          const response = await http.POST(`audio/notes/${noteId}/finalize`, {
            visit_id: visitId,
            acknowledged: acknowledged === true,
            action,
          });
          if ((response?.code === OK || response?.code === CREATED) && response?.data != null) {
            return response.data;
          }
          return response ?? null;
        } catch (error) {
          console.error('Error finalizing AI note:', error);
          return null;
        }
      },
      sendAiNoteEmail: async (noteId, email) => {
        try {
          const response = await http.POST(`audio/notes/${noteId}/email`, {
            email: email ?? '',
          });
          if ((response?.code === OK || response?.code === CREATED) && response?.data != null) {
            return response.data;
          }
          return response ?? null;
        } catch (error) {
          console.error('Error sending AI note email:', error);
          return null;
        }
      },
       //Save user
    saveActivityInChartVisits:wOrgIdMiddleware(async (url='',data,headers={})=>{
      try {
        const response = await http.POST(`${url}add-activity-visit`,data,headers)
          
            if((response.code===200 || response.code===201) && response.data){
              return response.data;
            }else{
              return response;
            }
          
      } catch (error) {
        console.error('Error fetching user:', error);
        if(error.status){
          const resData = error.data; 
          if(resData.code && resData.data){ 
            //delete-activity-visit
              return resData;
          }
        }
        
        // throw error;
      }  
    },true),
     //Delete Visits
     deleteActivityInChartInVisits:wOrgIdMiddleware(async (url='',  mappingId)=>{
      try {
        const response = await http.DELETE(`${url}delete-activity-visit/${mappingId}`);
        return response;    
      } catch (error) {
        if(error.status){
          const resData = error.data;
          if(resData.code && resData.data){
              return resData;
          }
        }
        console.error('Error fetching user:', error);
        throw error;
      }  
    }),
    getVisitsHistory:wOrgIdMiddleware(async(url,query={})=>{
      const queryString = new URLSearchParams(query).toString();
      try {
        // const orgId       = OrganizationService.getOrgId();
        const response    = await http.GET(`${url}appointment-history?`+queryString);
        
            if (response.code===OK) {
              return response.data;
            }
          
        } catch (error) {
          if(error.status){
            const resData = error.data;
            if(resData.code && resData.data){
                return resData;
            }
          }
          
          // throw error;
        } 
  }),
  getWaitingAndDischargeHistory:wOrgIdMiddleware(async(url,query={})=>{
    const queryString = new URLSearchParams(query).toString();
    try {
      const response    = await http.GET(`${url}get-currentdate-visits?`+queryString);
      
          if (response.code===OK) {
            return response.data;
          }
        
      } catch (error) {
        if(error.status){
          const resData = error.data;
          if(resData.code && resData.data){
              return resData;
          }
        }
        // throw error;
      } 
  }),
  getFutureDateAppointments:wOrgIdMiddleware(async(url,query={})=>{
    const queryString = new URLSearchParams(query).toString();
    try {
      const response    = await http.GET(`${url}get-future-appointments?`+queryString);
      
          if (response.code===OK) {
            return response.data;
          }
        
      } catch (error) {
        if(error.status){
          const resData = error.data;
          if(resData.code && resData.data){
              return resData;
          }
        }
        // throw error;
      } 
  }),
   //Save user
   updateVisitStatus:wOrgIdMiddleware(async (url,visitId,data)=>{
    try {
      const response = await http.PUT(`${url}update-visit-status/${visitId}`,data);
      
        if(response.code===200 && response.data){
          // UserService.storeProfile(resData.data);
         
          return response.data;
        }else{
          return response;
        }
    } catch (error) {
      if(error.status){
        const resData = error.data;
        if(resData.code && resData.data){
            return resData;
        }
      }
      console.error('Error fetching user:', error);
      throw error;
    }  
  },true),
  updateVisitBillingStatus:wOrgIdMiddleware(async (url,visitId,data)=>{
    try {
      const response = await http.PUT(`${url}update-billing-status/${visitId}`,data);
        if(response.code===200 && response.data){         
          return response.data;
        }else{
          return response;
        }
    } catch (error) {
      if(error.status){
        const resData = error.data;
        if(resData.code && resData.data){
            return resData;
        }
      }
      console.error('Error fetching user:', error);
      throw error;
    }  
  }),
  createFollowUp:wOrgIdMiddleware(async (url,data)=>{
    try {
      const response = await http.POST(`${url}employee-visits-followup/`,data);
      return response;
      
    } catch (error) {
      if(error.status){
        const resData = error.data;
        if(resData.code && resData.data){
            return resData;
        }
      }
      console.error('Error fetching user:', error);
      throw error;
    }  
  }),
  getEmployeeVisitsNotDischarged:wOrgIdMiddleware(async (url,data)=>{
    try {
      const response = await http.POST(`${url}get-employee-visits-not-discharged/`,data);
      return response;
      
    } catch (error) {
      if(error.status){
        const resData = error.data;
        if(resData.code && resData.data){
            return resData;
        }
      }
      console.error('Error fetching visits:', error);
      throw error;
    }  
  }),
  getQuestionnaireList: (async (payload) => {
    try {
      const response = await http.POST(`sendMdFormBulk`, payload);
      if (response?.code === OK) {
        return response;
      }
      return response;
    } catch (error) {
      if (error?.status) {
        const resData = error.data;
        if (resData?.code && resData?.data) {
          return resData;
        }
      }
      console.error("Error sending questionnaires:", error);
      throw error;
    }
  }),
  savePhysicalActivityForVisit:wOrgIdMiddleware(async (url,data)=>{
    try {
      const response = await http.POST(`${url}add-physical-activities`,data);
      
        if(response.code===200 && response.data){
          // UserService.storeProfile(resData.data);
         
          return response.data;
        }else{
          return response;
        }
      
    } catch (error) {
      if(error.status){
        const resData = error.data;
        if(resData.code && resData.data){
            return resData;
        }
      }
      console.error('Error fetching user:', error);
      throw error;
    }  
  }),
 
  getVisitLosTime: wOrgIdMiddleware(async (url,visitId) => {
    try {
      const response = await http.GET(`${url}get-visit-los/${visitId}`);
      if (response.code===OK && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching visit LOS time:', error);
      if(error.status){
        const resData = error.data;
        if(resData.code && resData.data){
            return resData;
        }
      }
    }
  }),
  getVisitTimeLine: wOrgIdMiddleware(async (url,visit_id={}) => {
    try {
      const response = await http.GET(`${url}get-visit-timeline/${visit_id}`);
     
        if(response.code===200 && response.data){
          return response.data;
        }
      
      return null;
    } catch (error) {
      console.error('Error fetching user:', error);
      // throw error;
    }
  }),
  getVisitChartTimeLine: wOrgIdMiddleware(async (url,visit_id={}) => {
    try {
      const response = await http.GET(`${url}get-chart-timeline/${visit_id}`);
      return response?.data;
    } catch (error) {
      console.error('Error fetching user:', error);
    }
  }),
  getEmailPdfResult:async(data)=>{
    const response=await http.POST(`/email-pdf-result`,data);
    return response;
  },
  
  getDashBoard:wOrgIdMiddleware(async (url,payload)=>{
    const response=await http.POST(`${url}dashboard`,payload);
    return response.data;
  }) ,
  getNewDashboardCounts:wOrgIdMiddleware(async (url,payload={})=>{
    const response=await http.POST(`${url}new-dashboard-counts`,payload);
    return response.data;
  }) ,
  getIncompleteCharting:wOrgIdMiddleware(async (url,payload={})=>{
    const response=await http.POST(`${url}incomplete-charting`,payload);
    return response.data;
  }) ,
  getReviewCompletedOrders:wOrgIdMiddleware(async (url,payload={})=>{
    const response=await http.POST(`${url}review-completed-orders`,payload);
    return response.data;
  }) ,
  getDeficientCharting:wOrgIdMiddleware(async (url,payload={})=>{
    const response=await http.POST(`${url}deficient-charting`,payload);
    return response.data;
  }) ,
  getEmployeeComplianceMonitor:wOrgIdMiddleware(async (url,payload={})=>{
    const response=await http.POST(`${url}employee-compliance-monitor`,payload);
    return response.data;
  }) ,
  getWorkRestrictions:wOrgIdMiddleware(async (url,payload={})=>{
    const response=await http.POST(`${url}work-restrictions`,payload);
    return response.data;
  }) ,
  getAllVisits:wOrgIdMiddleware(async (url,payload={})=>{
    const response=await http.POST(`${url}visits`,payload);
    return response.data;
  }) ,
  getOpenInvoices:wOrgIdMiddleware(async (url,payload={})=>{
    const response=await http.POST(`${url}open-invoices`,payload);
    return response.data;
  }) ,
  getDashboardCounts:wOrgIdMiddleware(async (url,payload={})=>{
    const response=await http.POST(`${url}dashboard-counts`,payload);
    return response.data;
  }) ,
  downloadEmployerServiceInvoice:wOrgIdMiddleware(async (url,payload={})=>{
    try {
      const response=await http.POST(`${url}download-employer-service-invoice`,payload);
      if (response.code === OK && response.data) {
        return response.data;
      }
      return null;
    } catch (error) {
      console.error('Error downloading invoice:', error);
      throw error;
    }
  }) ,
  clinicAvailability: wOrgIdMiddleware(async (url,clinic_id) => {
    try {
      const response = await http.GET(`${url}clinics/${clinic_id}/clinic-availability`);

        return response;

    } catch (error) {
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
    }
  }),
  printSchedule: wOrgIdMiddleware(async (url, data = {}) => {
    try {
      const response = await http.POST(`${url}print-visit-schedule`, data);
      if (response && response.code === OK && response.data) {
        return response.data;
      }
      // If response exists but code is not OK, it's an error response
      if (response && response.code !== OK) {
        // Create an error object with the response data
        const error = new Error(response.data?.error || 'Failed to generate visit schedule PDF');
        error.response = { data: response };
        error.data = response;
        throw error;
      }
      return null;
    } catch (error) {
      console.error('Error printing visit schedule:', error);
      throw error;
    }
  }),
    
  }
  
  export default VisitsService;